export const appHead = {"meta":[{"charset":"utf-8"},{"name":"msapplication-TileColor","content":"#2b5797"},{"name":"theme-color","content":"#ffffff"},{"name":"description","content":"Ειδήσεις με νέα της Κύπρου αλλά και από όλο τον κόσμο.  Τοπικές, πολιτικές, οικονομικές και αθλητικές ειδήσεις της Κύπρου και του εξωτερικού"},{"name":"title","content":"Ειδήσεις Κύπρος | Sigmalive"},{"name":"charset","content":"UTF-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"index, follow"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"HandheldFriendly","content":"true"},{"name":"theme-color","content":"#D01212"},{"name":"referrer","content":"no-referrer-when-downgrade"},{"name":"keywords","content":"sigma, cyprus news, news, ειδήσεις, Κύπρος, Σιγμα"},{"name":"apple-mobile-web-app-title","content":"Sigmalive"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"/safari-pinned-tab.svg","color":"#5bbad5"}],"style":[],"script":[{"src":"https://securepubads.g.doubleclick.net/tag/js/gpt.js","crossorigin":"anonymous","async":true}],"noscript":[],"bodyAttrs":{"class":"h-full font-sans"},"htmlAttrs":{"class":"h-full","style":"scroll-behaviour: smooth"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"